import { NgModule } from "@angular/core";
import { NoPreloading, RouterModule, Routes } from "@angular/router";
import { RedirectGuard } from "../../shared/guards/redirect.guard";
import { ContentGuard } from "../../shared/guards/content.guard";

const routes: Routes = [
  {
    path: "humanspaceflight",
    loadChildren: () =>
      import("../../pages/human-spaceflight/human-spaceflight-shell/human-spaceflight-shell.module").then(
        (m) => m.HumanSpaceflightShellModule
      ),
  },
  {
    path: "mars",
    redirectTo: "/humanspaceflight/mars",
    pathMatch: "full",
  },
  {
    path: "supplier",
    loadChildren: () =>
      import("../../pages/supplier/supplier-shell/supplier-shell.module").then((m) => m.SupplierShellModule),
  },
  {
    path: "launches",
    loadChildren: () =>
      import("../../pages/launches/launches-shell/launches-shell.module").then((m) => m.LaunchesShellModule),
  },
  {
    path: "vehicles",
    loadChildren: () =>
      import("../../pages/vehicles/vehicles-shell/vehicles-shell.module").then((m) => m.VehiclesShellModule),
  },
  {
    path: "rideshare",
    loadChildren: () =>
      import("../../pages/rideshare/rideshare-shell/rideshare-shell.module").then((m) => m.RideshareShellModule),
  },
  {
    path: "spacexai/starmind",
    loadChildren: () =>
      import("../../pages/satellites/ai-satellite/ai-satellite.page.module").then((m) => m.AiSatellitePageModule),
  },
  {
    path: "starshield",
    loadChildren: () =>
      import("../../pages/starshield/starshield-shell/starshield-shell.module").then((m) => m.StarshieldShellModule),
  },
  {
    path: "careers",
    loadChildren: () =>
      import("../../pages/careers/careers-shell/careers-shell.module").then((m) => m.CareersShellModule),
  },
  {
    path: "legal",
    canActivate: [RedirectGuard],
    component: RedirectGuard,
    data: {
      externalUrl: "https://supplierportal.spacex.com/",
    },
  },
  {
    path: "internships",
    loadChildren: () =>
      import("../../pages/internships/internships-shell/internships-shell.module").then(
        (m) => m.InternshipsShellModule
      ),
  },
  {
    path: "trademark",
    loadChildren: () =>
      import("../../pages/trademark/trademark-shell/trademark-shell.module").then((m) => m.TrademarkShellModule),
  },
  {
    path: "mission",
    loadChildren: () =>
      import("../../pages/mission/mission-shell/mission-shell.module").then((m) => m.MissionShellModule),
  },
  {
    path: "updates",
    loadChildren: () =>
      import("../../pages/updates/updates-shell/updates-shell.module").then((m) => m.UpdatesShellModule),
  },
  {
    path: "follow-dragon",
    loadChildren: () =>
      import("../../pages/follow-dragon/follow-dragon-shell/follow-dragon-shell.module").then(
        (m) => m.FollowDragonShellModule
      ),
  },
  {
    path: "vehicle-tracker",
    loadChildren: () =>
      import("../../pages/vehicle-tracker/vehicle-tracker-shell/vehicle-tracker-shell.module").then(
        (m) => m.VehicleTrackerShellModule
      ),
  },
  {
    path: "content",
    loadChildren: () =>
      import("../../pages/content-hub/content-hub-shell/content-hub-shell.module").then(
        (m) => m.ContentHubShellModule
      ),
    canLoad: [ContentGuard]
  },
  {
    path: "Mid-South",
    loadChildren: () =>
      import("../../pages/sites/memphis/memphis-shell.module").then((m) => m.MemphisShellModule),
  },
  {
    path: "mid-south",
    redirectTo: "/Mid-South",
    pathMatch: "full",
  },
  {
    path: "sites",
    loadChildren: () =>
      import("../../pages/sites/sites-shell/sites-shell.module").then((m) => m.SitesShellModule),
  },
  {
    path: "",
    loadChildren: () => import("../../pages/home/home-shell/home-shell.module").then((m) => m.HomeShellModule),
  },
  {
    path: "**",
    redirectTo: "/",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
      onSameUrlNavigation: "reload",
    }),
  ],
  exports: [RouterModule],
})
export class AppRootRoutingModule { }
